import { render, staticRenderFns } from "./MenuProductList.vue?vue&type=template&id=88891126&scoped=true&"
import script from "./MenuProductList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MenuProductList.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MenuProductList.vue?vue&type=style&index=0&id=88891126&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88891126",
  null
  
)

export default component.exports